module.exports = __webpack_public_path__ + "img/ContentPage-right-top.9fb13ba9.png";